module.exports = __webpack_public_path__ + "assets/img/erweima.31ca5a5c.png";